export default "__VITE_ASSET__b1ed19ca__"